/**
 * DB-4: "Every table has an empty state that explains what will appear there and
 * offers the action that creates the first one. 'No data' alone is not
 * acceptable." A first-run screen is what a merchant judges the product on.
 */
export function EmptyState({ title, description, blurb, action, icon: Icon, eyebrow, className = '' }) {
  description = description ?? blurb;
  return (
    <div className={`flex flex-col items-center justify-center px-6 py-14 text-center ${className}`}>
      {Icon && (
        <div className="mb-4 grid h-12 w-12 place-items-center rounded-2xl border border-line bg-surface-2 text-faint">
          <Icon className="h-5 w-5" />
        </div>
      )}
      {eyebrow && <div className="eyebrow mb-1.5">{eyebrow}</div>}
      <h3 className="text-base font-semibold text-ink">{title}</h3>
      {description && (
        <p className="mt-1.5 max-w-sm text-sm leading-relaxed text-muted">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export default EmptyState;
